export default __webpack_public_path__ + "static/wave-df42af91efd96ad889f7e5528c966af4.webp";